// extracted by css-extract-rspack-plugin
export default {"image":"Block-module__image____u41R","image-box":"Block-module__image-box___nUr6n","imageBox":"Block-module__image-box___nUr6n"};